import React from 'react';
import classNames from 'classnames';
import styles from './member-badge.module.scss';
/**
 * A member badge's title, rendered inline next to the author name.
 *
 * Replaces `Badge` from `@wix/members-badge-lib` (internal to Wix). The widget only ever used
 * the lib's `name-only` layout at `tiny` size, and it passed
 * `textStyle={{ font: 'inherit', fontWeight: 'inherit', color: 'inherit' }}`, which the lib
 * spreads last — so the badge's own `textColor` was deliberately ignored and the title took the
 * comment's secondary text style. Keep it that way: badges configured with a light text colour
 * (white on a coloured chip, which we never render) would otherwise be invisible here.
 */
const MemberBadge = ({ badge, className }) => {
    return (React.createElement("span", { className: classNames(styles.badge, className), title: badge.title }, badge.title));
};
export default MemberBadge;
//# sourceMappingURL=member-badge.js.map